import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TruncatePipe } from './truncate.pipe';
import { TruncatedPipe } from './truncated.pipe';

@NgModule({
	declarations: [TruncatePipe, TruncatedPipe],
	exports: [TruncatePipe, TruncatedPipe],
	imports: [CommonModule],
})
export class TruncateModule {}
